<dx-data-grid
  class="h-100"
  height="100%"
  [dataSource]="userLogs"
  [remoteOperations]="{ paging: true }"
  [allowColumnReordering]="true"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  noDataText="{{ 'Keine Daten vorhanden' | translate }}"
  [showBorders]="true"
  (onToolbarPreparing)="onGridToolbarPreparing($event)"
  (onExporting)="onExporting($event)"
>
  <dxo-paging [pageSize]="100"></dxo-paging>
  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-header-filter [visible]="true"></dxo-header-filter>

  <dxo-pager
    [showPageSizeSelector]="true"
    [allowedPageSizes]="[10, 20, 50, 100]"
    [showNavigationButtons]="true">
  </dxo-pager>

  <div *dxTemplate="let toolbaritem of 'minGroupsButtonTemplate'">
    <dx-button stylingMode="text" (onClick)="dataGrid.instance.collapseAll()" type="default" icon="chevronright" hint="{{ 'Alle Gruppen schliessen' | translate }}"></dx-button>
  </div>
  <div *dxTemplate="let toolbaritem of 'maxGroupsButtonTemplate'">
    <dx-button stylingMode="text" (onClick)="dataGrid.instance.expandAll()" type="default" icon="chevrondown" hint="{{ 'Alle Gruppen öffnen' | translate }}"></dx-button>
  </div>
  <div *dxTemplate="let toolbaritem of 'refreshButtonTemplate'">
    <dx-button stylingMode="text" type="default" text="{{ 'Aktualisieren' | translate }}" (onClick)="reload()" hint="{{ 'Aktualisieren' | translate }}"></dx-button>
  </div>

  <dxo-group-panel [visible]="true"></dxo-group-panel>

  <dxo-search-panel
    [visible]="true"
    [highlightCaseSensitive]="true"
    placeholder="{{ 'Logs werden durchsucht' | translate }}">
  </dxo-search-panel>

  <dxo-export [enabled]="true" [allowExportSelectedData]="false"></dxo-export>

  <dxi-column dataField="user" caption="{{ 'Benutzer' | translate }}"></dxi-column>
  <dxi-column dataField="userActionDisplay" caption="{{ 'Aktion' | translate }}"></dxi-column>

  <dxi-column
    dataField="userActionTime"
    caption="{{ 'Zeitpunkt' | translate }}"
    dataType="date"
    format="dd.MM.yyyy HH:mm:ss">
  </dxi-column>

  <dxi-column dataField="groupString" caption="{{ 'Kategorie' | translate }}"></dxi-column>
  <dxi-column dataField="catalog" caption="{{ 'Katalog' | translate }}"></dxi-column>
  <dxi-column dataField="supplerPid" caption="{{ 'Supplier PID' | translate }}"></dxi-column>

</dx-data-grid>
